import React from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import styles from './Balances.module.sass'
import {ReactComponent as TotalContractBalance} from './assets/total-contract-balance.svg'
import {ReactComponent as BonusRewardPool} from './assets/reward-pool.svg'
import {ReactComponent as MonthlyRewardPool} from './assets/reward-pool.svg'
import {ReactComponent as TotalPlayers} from './assets/total-players.svg'
import {ReactComponent as MyStakingCNR} from './assets/staked-crn.svg'
import {ReactComponent as StakedReward} from './assets/staked-reward.svg'
import {ReactComponent as InviteReward} from './assets/invite-reward.svg'
// import {ReactComponent as CnrLogo} from 'public/images/cnr-logo.jpg'
import {BalanceWithTimer} from "./BalanceWithTimer";


const balancesList = [{
    title: 'Total Contract Balance',
    propName: 'totalContractBalance',
    img: "images/cnr-logo.jpg",
    // icon: <TotalContractBalance/>,
    cur: 'CNR',
}, {
    withTimer: true,
    title: 'Bonus Reward Pool',
    propName: 'bonusRewardPool',
    img: "images/cnr-logo.jpg",
    cur: 'CNR',
    descPropName: 'bonusRewardPoolCountdown',
}, {
    withTimer: true,
    title: 'Harvest Pool',
    propName: 'monthlyRewardPool',
    img: "images/cnr-logo.jpg",
    cur: 'CNR',
    descPropName: 'monthlyRewardPoolCountdown',
}, {
    title: 'Total Players',
    propName: 'totalPlayers',
    img: "images/cnr-logo.jpg",
    // icon: <TotalPlayers/>,
}, {
    withCircular: true,
    title: 'My % Pool Share',
    propName: 'myStakingPercents',
    icon: '',
    cur: '%',
}, {
    title: 'My Staked CNR',
    propName: 'myStakedCNR',
    img: "images/cnr-logo.jpg",
    // icon: <MyStakingCNR/>,
    cur: 'CNR',
}, {
    title: 'My Stake Rewards',
    propName: 'myWithdrawableReward',
    img: "images/cnr-logo.jpg",
    // icon: <StakedReward/>,
    cur: 'CNR',
}, 
{
    title: 'Estimated BRP Share',
    propName: 'bonusRewardPool',
    img: "images/cnr-logo.jpg",
    cur: 'CNR',
    precentageFloat: 'myStakingPercents',
    precentageOfPool: 40
}, 
{
    title: 'Harvest Pool Share',
    propName: 'monthlyRewardPool',
    img: "images/cnr-logo.jpg",
    cur: 'CNR',
    precentageFloat: 'myStakingPercents',
    precentageOfPool: 50
}
]

export function Balances({ balances }) {
    return (
        <div className={styles.balance_grid}>
            {balancesList.map(i => {
                if (i.withTimer) return (<BalanceWithTimer
                    key={i.title}
                    img={i.img}
                    title={i.title}
                    amount={balances? balances[i.propName]: 0}
                    amountCur={i.cur}
                    seconds={balances && balances[i.descPropName]}
                />)
                // console.log('%cBalances.js line:90 balances[i.descPropName]', 'color: #007acc;',balances && balances.bonusRewardPoolCountdown,balances?.monthlyRewardPoolCountdown)

                return (
                    <div className={styles.box} key={i.title}>
                        <div className={styles.cap}>
                            {i.withCircular && (
                                <div style={{ width: 45, height: 45, marginLeft: 4, marginBottom: 11 }}>
                                    <CircularProgressbar
                                        strokeWidth={12}
                                        value={balances? balances[i.propName]: 0}
                                        styles={buildStyles({
                                            trailColor: '#222A2D',
                                            pathColor: '#00BE99',
                                        })}
                                    />
                                </div>
                            )}
                            {i.icon && i.icon}
                            {i.img && (<img src={i.img} alt="cnr logo" />)}
                        </div>
                        <div className={styles.title}>{i.title}</div>
                        {i.propName && (
                            <div className={styles.lastProp}>
                                <span className={styles.amount_amount}>{(balances && !i.precentageFloat) ? 
                                (balances[i.propName]+' ') : 
                                (balances && i.precentageFloat) ? ((((parseFloat(balances[i.propName])/100)*balances[i.precentageFloat])/100)*i.precentageOfPool).toFixed(2)+' ': '0 '}</span>
                                <span className={styles.amount_cur}>{i.cur ? i.cur : ''}</span>
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}
